/**
 * Decodes a base64 ECG payload into the signed sample values the live ECG modal plots. Returns an empty array for missing input; otherwise it atob-decodes the string and walks it two bytes at a time, combining each pair big-endian and sign-extending with 0xffff0000 when the high bit is set.
 *
 * @param base64 - Base64-encoded ECG sample block.
 * @returns The decoded signed ECG samples.
 */
const convertBase64ToArrayForEcg = (base64: string) => {
  if (!base64) {
    return [];
  }

  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = [];

  for (let i = 0; i < len; i += 2) {
    const byteA = binaryString.charCodeAt(i);
    const byteB = binaryString.charCodeAt(i + 1);
    const sign = byteA & (1 << 7);
    const x = ((byteA & 0xff) << 8) | (byteB & 0xff);
    if (sign) {
      const result = 0xffff0000 | x; // fill in most significant bits with 1's
      bytes.push(result);
    } else {
      bytes.push(x);
    }
  }

  return bytes;
};

export { convertBase64ToArrayForEcg };
